import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "breadcrumb d-flex align-items-center" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_5 = {
  key: 1,
  class: "breadcrumb-item active"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'TableBreadCrumbs',
  props: {
  title: {
    default: "home",
  },
},
  setup(__props) {

let props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Home ", -1)
          ]))]),
          _: 1
        })
      ]),
      (_ctx.main)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_ctx.main), 1))
        : _createCommentVNode("", true),
      (__props.title)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})